import React from "react";
import { ListBadge } from "@/features/shell/components/shared/List/List";
import { verificationStatusLabelMap } from "../../utils/verification";
import type { UserVerificationDataSourceAttemptStatus } from "../../types/Verification";

import { SearchIcon, TickIcon } from "@picklebet/ui";
import { ReactComponent as WarningIcon } from "../assets/warning.svg";
import { ReactComponent as ClockIcon } from "../../assets/clock.svg";
import { ReactComponent as PlusIcon } from "../../assets/plus-circle.svg";

type VerificationBadgeStatus = UserVerificationDataSourceAttemptStatus;

type VerificationBadgeProps = {
  status: VerificationBadgeStatus;
};

const statusToIcon: Record<VerificationBadgeStatus, React.ReactNode> = {
  UNVERIFIED: <PlusIcon />,
  IN_PROGRESS: <ClockIcon />,
  FAILED: <WarningIcon />,
  VERIFIED: <TickIcon />,
  VERIFIED_ADMIN: <TickIcon />,
  ERROR_OCCURRED: <WarningIcon />,
  REJECTED_FOR_RESUBMIT: <WarningIcon />,
  PENDING_REVIEW: <SearchIcon />,
  PENDING_MANUAL_REVIEW: <SearchIcon />,
};

const statusToVariant: Record<VerificationBadgeStatus, any> = {
  UNVERIFIED: "neutral",
  IN_PROGRESS: "warning",
  ERROR_OCCURRED: "danger",
  REJECTED_FOR_RESUBMIT: "danger",
  FAILED: "danger",
  VERIFIED: "success",
  VERIFIED_ADMIN: "success",
  PENDING_REVIEW: "info",
  PENDING_MANUAL_REVIEW: "info",
};

const VerificationBadge = ({ status }: VerificationBadgeProps) => {
  const statusText = verificationStatusLabelMap[status];

  return (
    <ListBadge variant={statusToVariant[status]} icon={statusToIcon[status]}>
      {statusText}
    </ListBadge>
  );
};

export { VerificationBadge };
